/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    homework_id: number;
    score: string;
    comment: string;
    used_time?: number;
}
interface IOutput {
    score_ret: string;
}

export const submitScore = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.SUBMIT_SCORE, data);
};
